module.exports = __webpack_public_path__ + "static/img/4.648094f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/4.jpg
// module id = byZM
// module chunks = 1